<div id="student-life-home" class="watermark py-5">
  <div class="container-fluid px-lg-5">

    <!-- Section Heading -->
    <div class="text-center mb-4">
      <h2 class="sl-heading-orange">Student Life at Shah Satnam Ji Girls' College</h2>
      <h3 class="sl-subheading">Where Dreams Take Flight</h3>
    </div>

    <!-- Intro Text -->
    <p class="sl-intro mb-4">
      Welcome to Shah Satnam Ji Girls' College, a place where education transcends textbooks and becomes a transformative
      journey. Our commitment to excellence, innovation, and holistic development shapes the lives of our students. Let's
      explore what makes student life at our institution truly exceptional:
    </p>

    <!-- Video Player -->
    <div class="sl-video-wrap mb-5">
      <video class="sl-video" controls preload="metadata" poster="">
        <source src="/assets/mp4/student_life_video1.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
      </video>
    </div>

    <!-- Photo Gallery Grid -->
    <div class="row g-3 mb-5">
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img1.jpg" alt="Student Life 1" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img2.jpg" alt="Student Life 2" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img3-1400x631.jpg" alt="Student Life 3" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img4.jpg" alt="Student Life 4" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img5.jpg" alt="Student Life 5" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img6-1200x800.jpg" alt="Student Life 6" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img7-1200x800.jpg" alt="Student Life 7" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img8-1200x800.jpg" alt="Student Life 8" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img9-1328x800.jpg" alt="Student Life 9" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img11-1200x800.jpg" alt="Student Life 11" class="sl-photo">
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="sl-photo-card">
          <img src="/assets/img/home/student-life/student_life_img8-1200x800 (1).jpg" alt="Student Life 8b" class="sl-photo">
        </div>
      </div>
    </div>

    <!-- Feature Highlights -->
    <div class="sl-features">

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Academic Excellence</h4>
        <p>Our rigorous curriculum, dedicated faculty, and state-of-the-art facilities empower students to achieve their highest
          potential. Whether it's mastering complex concepts or exploring new horizons, academic excellence is at the core of our
          mission.</p>
      </div>

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Innovative Spirit</h4>
        <p>Creativity knows no bounds here. Workshops, seminars, and collaborative projects ignite the innovative spirit within
          our students. From coding challenges to art exhibitions, we encourage them to think beyond conventions and create
          something extraordinary.</p>
      </div>

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Moral and Ethical Values</h4>
        <p>Education isn't just about knowledge; it's about character. At Shah Satnam Ji Girls' College, we instil strong moral
          and ethical values. Integrity, compassion, and responsibility are woven into the fabric of our community.</p>
      </div>

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Holistic Development</h4>
        <p>Life at our college extends beyond classrooms. Sports, arts, cultural events, and leadership programs provide a canvas
          for self-expression. We believe in nurturing well-rounded individuals who excel academically and contribute
          meaningfully to society.</p>
      </div>

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Enriching Experiences</h4>
        <p>At Shah Satnam Ji Girls' College, we go beyond academics to create memorable experiences for our students.</p>
        <ul class="sl-list">
          <li><strong>Educational Tours:</strong> We believe that learning happens beyond the four walls of a classroom. Our
            students embark on educational tours that broaden their horizons, expose them to new cultures, and provide practical
            insights.</li>
          <li><strong>Restaurant Visits:</strong> Food brings people together! Our students enjoy occasional visits to local
            restaurants, where they bond over meals and create lasting memories.</li>
          <li><strong>Responsibility in Celebrations:</strong> Students actively participate in organizing welcome parties,
            farewells, and other college events. These responsibilities enhance their leadership skills and foster a sense of
            community.</li>
          <li><strong>Functions and Celebrations:</strong> From cultural festivals to sports meets, our campus buzzes with
            excitement during various functions. Students showcase their talents, collaborate, and celebrate achievements.</li>
          <li><strong>Balancing Study and Fun:</strong> While academics are crucial, we recognize the importance of downtime.
            Students are encouraged to strike a balance between study and leisure. Whether it's a friendly game of cricket or a
            creative workshop, there's always room for enjoyment.</li>
        </ul>
      </div>

      <div class="sl-feature-item">
        <h4 class="sl-feature-title">Supportive Community</h4>
        <p>Our campus is a heaven—a ragging-free zone where every student feels respected and valued. Lifelong friendships are
          forged, and diversity is celebrated.</p>
      </div>

    </div>

    <!-- Call to Action Banners -->
    <div class="sl-cta-wrap mt-5">
      <div class="sl-cta-banner">Join us on this remarkable journey.</div>
      <div class="sl-cta-banner">Let your dreams take flight at Shah Satnam Ji Girls' College!</div>
    </div>

  </div>
</div>
